import { useAppSelector } from 'app/hooks';
import { selectRol, selectToken } from 'features/auth';
import { UnifiedLoader } from 'components/loader';
import { shallowEqual } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { SERVER_ROUTE } from 'utils/constants';
import { useEffect, useState } from 'react';

interface PrivadaProps {
    children: React.ReactNode;
    allowedRoles?: number[];
}

const Privada: React.FC<PrivadaProps> = ({ children, allowedRoles }) => {
    const token = useAppSelector((state) => selectToken(state), shallowEqual);
    const idRol = useAppSelector((state) => selectRol(state), shallowEqual);
    const [isChecking, setIsChecking] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsChecking(false);
        }, 100);

        return () => clearTimeout(timer);
    }, []);

    if (isChecking) {
        return <UnifiedLoader fullScreen text="Verificando acceso..." />;
    }

    if (!token) {
        return <Navigate to={`${SERVER_ROUTE}/principal`} replace />;
    }

    if (allowedRoles && allowedRoles.length > 0 && (!idRol || !allowedRoles.includes(idRol))) {
        return <Navigate to={`${SERVER_ROUTE}/dashboard`} replace />;
    }

    return <>{children}</>;
}

export default Privada; 
